import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Card } from '@/components/ui/card';
import { ListChecks } from 'lucide-react';

export function ForEachNode({ data, selected }: any) {
  const itemsPath: string = data?.items_path || '';
  // Show just the tail of the items path (e.g. "outputs.new_findings").
  const itemsLabel = itemsPath
    .replace(/^\{\{\s*/, '')
    .replace(/\s*\}\}$/, '')
    .split('.')
    .slice(-2)
    .join('.');
  const subtitle = itemsLabel ? `for each item in ${itemsLabel}` : 'for each item in a list';
  return (
    <div className="relative">
      <Handle type="target" position={Position.Left} className="!bg-primary !w-2 !h-2" />
      <Handle type="source" position={Position.Right} className="!bg-primary !w-2 !h-2" />
      <Card
        className={`w-[260px] p-3 border-2 transition-shadow cursor-pointer ${
          selected ? 'border-primary shadow-lg ring-2 ring-primary/20' : 'border-zinc-300 dark:border-zinc-700'
        } bg-zinc-50 dark:bg-zinc-900/40`}
      >
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-zinc-100 dark:bg-zinc-800 shrink-0">
            <ListChecks className="w-4 h-4 text-zinc-900 dark:text-zinc-100" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-medium text-zinc-500 dark:text-zinc-400 uppercase tracking-wide truncate">For Each</div>
            <div className="text-sm font-semibold truncate">{data.label || 'For Each'}</div>
            <div className="text-[11px] text-zinc-500 dark:text-zinc-400 truncate" title={subtitle}>{subtitle}</div>
          </div>
        </div>
      </Card>
    </div>
  );
}
